import spacingClasses from "./spacingClasses";

export const getSpacingClasses = (attributes) => {
    const {
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        paddingTopMobile,
        paddingBottomMobile,
        paddingLeftMobile,
        paddingRightMobile,
        marginTopMobile,
        marginBottomMobile,
        marginLeftMobile,
        marginRightMobile,
    } = attributes;

    return `
        ${spacingClasses.pt[paddingTopMobile] || ''} ${spacingClasses.mdPt[paddingTop] || ''}
        ${spacingClasses.pb[paddingBottomMobile] || ''} ${spacingClasses.mdPb[paddingBottom] || ''}
        ${spacingClasses.pl[paddingLeftMobile] || ''} ${spacingClasses.mdPl[paddingLeft] || ''}
        ${spacingClasses.pr[paddingRightMobile] || ''} ${spacingClasses.mdPr[paddingRight] || ''}
        ${spacingClasses.mt[marginTopMobile] || ''} ${spacingClasses.mdMt[marginTop] || ''}
        ${spacingClasses.mb[marginBottomMobile] || ''} ${spacingClasses.mdMb[marginBottom] || ''}
        ${spacingClasses.ml[marginLeftMobile] || ''} ${spacingClasses.mdMl[marginLeft] || ''}
        ${spacingClasses.mr[marginRightMobile] || ''} ${spacingClasses.mdMr[marginRight] || ''}
    `.trim();
};
